import React, { useState, useEffect, forwardRef } from 'react';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { Form } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBR);

const DateFilterInput = ({ 
  label, 
  value, 
  onChange, 
  error, 
  placeholder = '__/__/____', 
  required = false 
}) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (value) {
      const parsedDate = parseDate(value);
      setDate(parsedDate);
    } else {
      setDate(null);
    }
  }, [value]);

  const parseDate = (dateString) => {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (dateRegex.test(dateString)) {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    if (selectedDate) {
      const formattedDate = selectedDate.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      onChange(formattedDate);
    } else {
      onChange('');
    }
  };

  const handleInputBlur = (e) => {
    const inputValue = e.target.value;
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (dateRegex.test(inputValue)) {
      const parsedDate = parseDate(inputValue);
      if (parsedDate) {
        handleDateChange(parsedDate);
      } else {
        onChange('');
      }
    } else {
      onChange('');
    }
  };

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <InputMask
      mask="99/99/9999"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      onClick={onClick}
      onBlur={handleInputBlur}
      ref={ref}
    />
  ));

  return (
    <Form.Group className="mb-3 w-100">
      {label && <Form.Label className="mb-1 d-block">{label}</Form.Label>}
      <div className="position-relative">
        <DatePicker
          selected={date}
          onChange={handleDateChange}
          dateFormat="dd/MM/yyyy"
          locale="pt-BR"
          customInput={<CustomInput />}
          placeholderText={placeholder}
          autoComplete='off'
        />
        {error && <small className="text-danger mt-1 d-block">{error.message}</small>}
      </div>
    </Form.Group>
  );
};

export default DateFilterInput;